__turbopack_context__.v({
  "addresses": "EJDBqW_addresses",
  "columnOne": "EJDBqW_columnOne",
  "columnThree": "EJDBqW_columnThree",
  "columnTwo": "EJDBqW_columnTwo",
  "connectItem": "EJDBqW_connectItem",
  "connectWrapper": "EJDBqW_connectWrapper",
  "detailsContainer": "EJDBqW_detailsContainer",
  "detailsContent": "EJDBqW_detailsContent",
  "detailsHeading": "EJDBqW_detailsHeading",
  "extraWrapper": "EJDBqW_extraWrapper",
  "languages": "EJDBqW_languages",
  "licenseList": "EJDBqW_licenseList",
  "licenses": "EJDBqW_licenses",
  "officeHours": "EJDBqW_officeHours",
  "timeRange": "EJDBqW_timeRange",
});
